import type { FC } from "react";

import { FormSelect as UIFormSelect } from "@jti/ui/components/ContactForm";

import type { formSelectInputs } from "./FormSelect.builder";

export type FormSelectBuilderProps = BuilderComponentProps<typeof formSelectInputs>;

export const FormSelect: FC<FormSelectBuilderProps> = ({
  id,
  label,
  placeholder,
  dropdownValues,
  required,
  requiredMessage,
}) => {
  return (
    <UIFormSelect
      id={id}
      dataTestId={id}
      label={label}
      placeholder={placeholder || ""}
      dropdownValues={dropdownValues}
      validationRules={{
        required: required ? requiredMessage || true : false,
      }}
    />
  );
};
